<h2 mat-dialog-title>{{ title | translate }}</h2>
<mat-dialog-content>
  {{ text | translate }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ cta | translate}}</button>
</mat-dialog-actions>
